import { ChangeDetectionStrategy, ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { APP_SETTINGS, AuthService, UtilityService } from '@services';
import { Subscription } from 'rxjs';
import { AdminService } from '../admin/admin.service';
import { CmsNavbarService } from '../cms-navbar/cms-navbar.service';
import { UserProfileService } from '../user-profile/user-profile.service';
import { NgIf, NgFor } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        RouterLink,
        NgFor,
    ],
})
export class NavbarComponent implements OnInit, OnDestroy {

  public brand_icon_image;
  public brand_icon_color;
  public brandType: boolean;
  public isExternal: string;
  private subscription: Subscription[] = [];
  private loadEPCLinkURL: string;
  private originChecker: string;
  private brandTypeName: string;
  private username: string;
  public isCar: boolean = false;

  screenWidth: number;
  APP_SETTINGS: any;
  setBackgroundStyle: {};
  setFontStyle: {};
  public hideNavbar: boolean;
  public ossLinks: {};

  bulletinLabel = 'TRI Bulletins';
  userRoles = {};

  constructor(
    private readonly utilityService: UtilityService,
    private readonly userProfileService: UserProfileService,
    private readonly cmsNavbarService: CmsNavbarService,
    private readonly authService: AuthService,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly adminService: AdminService,
    private readonly ngZone: NgZone

  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    this.userRoles = JSON.parse(localStorage.getItem('USER_INFO'));
    if (this.userRoles) {
      APP_SETTINGS.isMOTORRAD = this.userRoles['isMotorrad'];
      APP_SETTINGS.isRollsRoyce = this.userRoles['isRollsRoyce'];
    }

    this.APP_SETTINGS = APP_SETTINGS;

    if (this.APP_SETTINGS.isBMW == 'true' || this.APP_SETTINGS.isMINI == 'true') {
      this.isCar = true;
    }

    this.hideNavbar = false;
    this.isExternal = this.APP_SETTINGS['isExternal'];
    this.username = this.authService.getUserName();

    this.applyBrandStyles();
   

    this.ngZone.runOutsideAngular(() => {
      const styleCheck = setInterval(() => {
        const userRoles = JSON.parse(localStorage.getItem('USER_INFO'));
        if (userRoles) {
          APP_SETTINGS.isMOTORRAD = userRoles['isMotorrad'];
        }

        if (APP_SETTINGS.isMINI != '' && APP_SETTINGS.isBMW != '') {
          clearInterval(styleCheck);
          this.ngZone.run(() => {
            this.userRoles = userRoles;
            this.APP_SETTINGS = APP_SETTINGS;
            this.isCar = this.APP_SETTINGS.isBMW == 'true' || this.APP_SETTINGS.isMINI == 'true';
            this.isExternal = this.APP_SETTINGS['isExternal'];
            this.applyBrandStyles();

            this.changeDetector.detectChanges();
            if (this.APP_SETTINGS.isExternal == 'true') {
              this.subscription.push(this.userProfileService.getCurrentOSSLinks().subscribe(data => {
                if (data) {
                  this.ossLinks = data.sort(function (a, b) { return a.linkOrder - b.linkOrder });
                }
              }));
            }
          });
        }
      }, 1000);
       this.changeDetector.detectChanges();
    });

  }

  private applyBrandStyles(): void {
    if (this.APP_SETTINGS.isMINI == 'true') {
      this.setBackgroundStyle = { 'background-color': '#ffffff' };
      this.setFontStyle = { 'color': '#000000' };
    }
    if (this.APP_SETTINGS.isRollsRoyce == 'true') {
      this.setBackgroundStyle = { 'background-color': '#281432' };
      this.setFontStyle = { 'color': '#ffffff' };
    }
    if (this.APP_SETTINGS.isBMW == 'true') {
      this.setBackgroundStyle = { 'background-color': '#1c69d4' };
      this.setFontStyle = { 'color': '#ffffff' };
    }
    if (this.APP_SETTINGS.isMOTORRAD === 'true') {
      this.setBackgroundStyle = { 'background-color': '#1c69d4' };
      this.setFontStyle = { 'color': '#ffffff' };
      this.bulletinLabel = "Authority Bulletins";
    }
  }

  loadEPCLink() {
    this.subscription.push(this.cmsNavbarService.getOriginCheckerForEPCLink().subscribe(data => {
      this.originChecker = data.origin_checker;
      this.brandTypeName = this.brandType ? "MINI" : "BMW";

      this.loadEPCLinkURL = "https://www.parts.bmwgroup.com/tetis/startTetisAction.do?DOMAIN=NAtechinfo&comes_from=www.bmwtis.net&module=asap&origin_checker=";
      this.loadEPCLinkURL = this.loadEPCLinkURL + "" + this.originChecker;
      this.loadEPCLinkURL = this.loadEPCLinkURL + "&brand=" + this.brandTypeName;
      this.loadEPCLinkURL = this.loadEPCLinkURL + "&user_id=" + this.username;
      window.open(this.loadEPCLinkURL, '_blank');
    }));
  }

  ngOnDestroy(): void {
    this.subscription.forEach(s => s.unsubscribe());
  }

}
